import { environment } from "../environments/environment";

export const userReadWriteGroups = {
    DLI: environment.adminGroups // SJP-TrainOnTime-Admin-Dev
};